import { useState, useEffect } from 'react';

/**
 * Hook pour détecter si l'utilisateur est sur un appareil mobile
 * Utilise une détection basée sur la largeur d'écran ET l'user agent
 * pour une détection plus fiable
 */
export const useDeviceDetection = () => {
  // Détection initiale synchrone basée sur la largeur ET l'user agent
  const getIsMobile = (): boolean => {
    if (typeof window === 'undefined') return false;
    
    // Détection par user agent (prioritaire pour éviter les faux positifs)
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileByUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    
    // Si l'user agent indique clairement un mobile, retourner true
    if (isMobileByUA) {
      return true;
    }
    
    // Sinon, vérifier la largeur d'écran (seuil: 768px pour être plus strict)
    // On utilise 768px au lieu de 1024px pour éviter de bloquer les petits écrans desktop
    const isMobileByWidth = window.innerWidth < 768;
    
    return isMobileByWidth;
  };

  const [isMobile, setIsMobile] = useState<boolean>(getIsMobile);

  useEffect(() => {
    // Mise à jour lors du redimensionnement
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };

    window.addEventListener('resize', handleResize);
    // Vérification initiale après le montage (pour éviter les problèmes SSR)
    setIsMobile(getIsMobile());

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile };
};

